import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { CSSTransitionGroup } from "react-transition-group";

import "./ErrorBlock.scss";

const ErrorBlock = ({
	message,
}) => {
	return (
		<CSSTransitionGroup
			className={classnames({
				"payment-error-block": true,
			})}
			transitionName="payment-error-block-animation"
			transitionEnterTimeout={200}
			transitionLeaveTimeout={200}
		>
			{message &&
				<div>
					{message}
				</div>
			}

			{!message &&
				<div />
			}
		</CSSTransitionGroup>
	);
};

ErrorBlock.propTypes = {
	message: PropTypes.string.isRequired,
};

export default ErrorBlock;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ErrorBlock/index.jsx